export class GameState {
    public sceneIndex: number;
    public mapKey: string;
    // Determines weather in the current scene
    public hasSnow: boolean;
    public hasRain: boolean;
    public hasClouds: boolean;
    public hasFog: boolean;

    /**
     * This is a reference to the current game state throughout the game
     * Dynamically changes!
     */
    public static current: GameState;

    constructor(sceneIndex: number, mapKey: string) {
        this.sceneIndex = sceneIndex;
        this.mapKey = mapKey;
    }

    public static GAME_STATES: GameState[] = [
        {
            sceneIndex: 1,
            mapKey: "map1",
            hasSnow: false,
            hasRain: false,
            hasClouds: false,
            hasFog: false,
        },
        {
            sceneIndex: 2,
            mapKey: "map2",
            hasSnow: true,
            hasRain: false,
            hasClouds: false,
            hasFog: false,
        },
        {
            sceneIndex: 3,
            mapKey: "map3",
            hasSnow: false,
            hasRain: true,
            hasClouds: true,
            hasFog: true,
        },
    ];
}



// WEBPACK FOOTER //
// ./src/games/DiseasedTreesGame/objects/GameState.ts